import { useEffect } from "react"
import { Button } from "web/components"
import TileSet from "web/components/TileSet/TileSet"
import { UserMessageTile } from "web/components/Tiles"
import useAddTileWizard from "web/components/AddTileWizard/useAddTileWizard"
import { UseOverviewUtils } from "web/utils/hooks/useOverview.utils"
import { useOverview } from "web/hooks/data"

function TileBlankSlate() {
  return <UserMessageTile message={'Add a tile using the "Add Tile" button.'} />
}

export default function OverviewLayout({ overviewTemplateId }) {
  const overviewFetchParams = UseOverviewUtils.prepareRequestProperties(
    true,
    overviewTemplateId
  )

  const selectedOverviewTemplate = useOverview({
    overviewFetchParams,
  })

  const { subject_type: subjectType } = selectedOverviewTemplate

  const availableTiles = selectedOverviewTemplate.tiles

  const addTile = useAddTileWizard({
    isTemplate: true,
    overviewFetchParams,
    subjectType,
  })

  async function handleAddTile() {
    await addTile()
    selectedOverviewTemplate.refresh()
  }

  useEffect(() => {
    function handleOpenWizard() {
      selectedOverviewTemplate.refresh()
      handleAddTile()
    }

    window.addEventListener(
      "event-dispatcher:open-add-tile-wizard",
      handleOpenWizard
    )
    return () =>
      window.removeEventListener(
        "event-dispatcher:open-add-tile-wizard",
        handleOpenWizard
      )
  })

  return (
    <div className="rounded-md border border-gray-50 bg-white p-5 pb-5 shadow-sm">
      <div className="mb-2 grid grid-cols-2 border-b pb-2">
        <h1 className="h-full text-xl font-bold">
          {selectedOverviewTemplate.template_label}
        </h1>
        <div className="flex justify-end">
          <Button onClick={handleAddTile}>Add Tile</Button>
        </div>
      </div>
      {availableTiles.length > 0 ? (
        <TileSet
          tiles={availableTiles}
          maxColumns={2}
          onMoveTile={selectedOverviewTemplate.handleMoveTile}
          isTemplate
          subjectType={subjectType}
          overview={selectedOverviewTemplate}
        />
      ) : (
        <TileBlankSlate />
      )}
    </div>
  )
}
